// Mock data for ApZelio Interactive Consulting Platform

export const navLinks = [
  { label: 'Services', path: '/services' },
  { label: 'Tech Stack', path: '/tech-stack' },
  { label: 'Methodology', path: '/methodology' },
  { label: 'Portfolio', path: '/portfolio' },
  { label: 'Testimonials', path: '/testimonials' },
  { label: 'Blog', path: '/blog' },
  { label: 'Contact', path: '/contact' },
];

export const heroData = {
  badge: 'US-Based Digital Excellence',
  titleLine1: 'The',
  titleHighlight: 'Intelligent',
  titleLine2: 'Ether',
  description: 'Bridging high-end digital architecture with AI-driven velocity. We build software that defines the future of enterprise infrastructure.',
  ctaPrimary: 'Architect Your Vision',
  ctaSecondary: 'View Methodology',
  stats: [
    { label: 'Active Nodes', value: '1,402+' },
    { label: 'LLM Velocity', value: '98.2ms' },
  ],
};

export const coreCompetencies = [
  {
    icon: 'Bot',
    title: 'AI Integration & LLM Ops',
    description: 'Harness the power of custom Large Language Models and agentic workflows integrated directly into your existing ecosystem.',
    tags: ['PyTorch', 'LangChain'],
    size: 'large',
  },
  {
    icon: 'CloudCheck',
    title: 'Cloud Native Arch',
    description: 'Serverless and microservices architecture designed for infinite scale and zero downtime.',
    size: 'small',
    accent: 'tertiary',
  },
  {
    icon: 'Terminal',
    title: 'Custom SaaS',
    description: 'Bespoke software solutions built with Go, Rust, and TypeScript for high-performance business logic.',
    size: 'small',
  },
  {
    icon: 'Shield',
    title: 'Security Audits',
    description: 'Comprehensive penetration testing and compliance auditing for fintech and health-tech sectors.',
    size: 'large',
    hasImage: true,
    image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuC-BZbwSbqGLMZktxLD2whEsNLTfjccenudaSZUa5nim14ISATJYT0wN3LlRTDQJr_GbSppa4Z7MPY5I4CtPaF7J9ZCm5rmj54ZsLowikZN1c_wUtcrpcABTmdTTBrDx9Ka31YynZafOSMMcsVNKQ9EwthyqcOFOzKtHagzf4K3D1BbfOmjcg_AR1Ei68MOP78kwttriv_3spTAJUf9lcIEEVG6gWwf8bI6HvrubLAVqz7ynzbA8fXEmXpITZSj_iLZsHyLo8MY9ts3',
  },
];

export const techStackData = {
  title: 'Modern',
  titleHighlight: 'Foundations',
  description: "We don't chase trends; we leverage battle-tested technologies that power the modern web. Our stack is optimized for performance, security, and developer velocity.",
  backend: ['Go / Node.js', 'PostgreSQL', 'Redis'],
  frontend: ['React / Next.js', 'Tailwind CSS', 'TypeScript'],
};

export const whyApzelio = [
  {
    icon: 'BadgeCheck',
    title: 'On-Time Delivery',
    description: 'We utilize predictive project management to ensure every milestone is met without compromise.',
    accent: 'primary',
  },
  {
    icon: 'Headphones',
    title: 'Professional Support',
    description: 'Direct access to lead architects and engineers. No middle-men, just expert guidance.',
    accent: 'tertiary',
  },
  {
    icon: 'Flag',
    title: 'US-Based Talent',
    description: 'Strategically located across the US to provide seamless communication and time-zone alignment.',
    accent: 'secondary',
  },
];

export const servicesData = {
  hero: {
    label: 'Our Capabilities',
    title: 'Architecting the',
    titleHighlight: 'Intelligent Ether',
    titleEnd: 'for Digital Growth.',
    description: 'From agile MVPs to resilient enterprise ecosystems, we build the infrastructure of tomorrow with AI at the core.',
  },
  aiDriven: {
    badge: 'CORE COMPETENCY',
    title: 'AI-Driven Application Development',
    description: "We don't just add AI; we build applications where machine learning is the heartbeat. Our specialized engineers integrate LLMs, computer vision, and predictive analytics into seamless user experiences.",
    features: [
      { icon: 'Brain', title: 'LLM Orchestration', desc: 'Custom RAG pipelines and agentic workflows.' },
      { icon: 'Database', title: 'Predictive Engines', desc: 'Converting raw data into actionable foresight.' },
    ],
    image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCkSFS0aXSr5ko1SoTvqcZAEFEn9ivSo2nA2mSmc4LDGoos3Jep_CrbpnmCri7bFZLjAGkQ2mdMUrejbJlgUIyA2Ivx3uSBVTgG3NSYjmaZ6swKd8_RbhFlHcP89kwlOrhZYOvOtHcsLirT3HuddpLlv_Qj9Zq2IfvGZhbXSsWgBkaPSU3Gxto3sXKkGvbgPnbEYBeHzpmVdhuKoo4QJpnm7_kWy-4k70WjgrorU4EnxHjnh7LPbhi1qk6aTp7sE5KJ7aaw-8yAEvYN',
  },
  tiers: [
    {
      icon: 'Rocket',
      title: 'Rapid MVP & Growth',
      description: 'Fast-track your entry into the market with high-fidelity prototypes and scalable initial releases designed for validation.',
      features: ['Modern Web & Mobile Apps', 'Cloud Native Architecture', '6-Week Launch Cycle'],
      size: 'small',
    },
    {
      icon: 'Network',
      title: 'Scale-Up Infrastructure',
      description: 'For established products needing a performance overhaul. We optimize for high traffic, complex data relationships, and cross-platform synergy.',
      popular: true,
      subFeatures: [
        { title: 'Microservices', desc: 'Decoupled, resilient backend logic.' },
        { title: 'DevOps 2.0', desc: 'Automated CI/CD & orchestration.' },
      ],
      image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuAw76bH6aqUi-ZEwfEvXOqjQNCkQrWEMoRlTt-vzVKaPnXNC-yxyulk7Zw5L1j2AFkAIyi5x9hH9ZrvyXoxSE-IMfWyZNqtoUyEsE_mnrSJvHEjw8wCPmtlaz6zrQzRNdkIofq_etqyKmwQWyaUE5XUICOXYvffuaXMufbZlZuAVov5Vk7kcwXO_EiC6nphqrZeP0HC0umhh9fN6Mbn8bEQZAsfAc3mTQkCnnoMuabV-1YjTbJgt0uyEHjbg0LkDo06Dy1fwz2RMkXL',
      size: 'medium',
    },
    {
      icon: 'Building2',
      title: 'Enterprise Digital Excellence',
      description: 'Large-scale systemic transformation for global brands. High-availability systems, legacy migration, and bespoke AI integrations at a massive scale.',
      tags: ['Big Data', 'Security Audits', 'Compliance', 'Distributed Systems', '24/7 Monitoring'],
      size: 'full',
    },
  ],
  support: [
    {
      title: 'The Maintenance Retainer',
      description: 'Regular security patches, framework updates, and small feature tweaks to keep things fresh.',
      features: ['Monthly Security Audits', 'Performance Tuning', '12h Response Time'],
      accent: 'primary',
    },
    {
      title: 'The Innovation Partnership',
      description: 'Dedicated engineering bandwidth to continuously build and iterate on new features and AI capabilities.',
      features: ['Dedicated Sprint Team', 'AI Model Re-training', 'Priority 1 Support'],
      accent: 'tertiary',
    },
    {
      title: 'Self-Managed Handoff',
      description: 'We empower your internal team with extensive documentation, video walkthroughs, and architecture diagrams for a complete handoff.',
      accent: 'secondary',
      included: true,
    },
  ],
};

export const techStackPageData = {
  hero: {
    label: 'Engineered for Performance',
    title: 'The Architecture of',
    titleHighlight: 'Modern Intelligence.',
    description: "We don't just build apps; we architect high-performance ecosystems. Our stack is curated for extreme scalability, AI integration, and mission-critical reliability.",
  },
  techGrid: [
    {
      name: 'Go (Golang)',
      subtitle: 'High-Concurrency Backend Systems',
      description: 'We utilize Go for building cloud-native microservices that require low latency and high throughput. It is the backbone of our data-intensive AI pipelines.',
      tags: ['Microservices', 'Kubernetes Native', 'Binary Efficiency'],
      icon: 'Gauge',
      size: 'large',
    },
    {
      name: 'AWS',
      description: 'Global-scale infrastructure with automated scaling and serverless execution. We leverage Lambda, S3, and SageMaker for seamless AI deployment.',
      icon: 'Cloud',
      stats: ['99.99% Uptime', 'Auto-Scaling'],
      size: 'small',
      accent: 'tertiary',
    },
    {
      name: 'Python & AI',
      description: 'The language of intelligence. We use Python to develop custom LLM workflows, predictive models, and deep learning neural networks.',
      icon: 'BrainCircuit',
      subTags: ['PyTorch', 'Scikit-Learn', 'Pandas', 'OpenAI'],
      size: 'medium',
    },
    {
      name: 'Node.js & React',
      description: 'Creating snappy, real-time user experiences with Next.js and high-speed Node.js event loops. Seamlessly connecting front-end beauty to back-end logic.',
      icon: 'Code2',
      metric: { value: '0.1s', label: 'Response Time Goal' },
      size: 'medium',
    },
    {
      name: 'Redis',
      description: 'Sub-millisecond data access for caching, session management, and real-time pub/sub messaging.',
      icon: 'Database',
      size: 'small',
    },
  ],
  reliability: {
    title: 'Enterprise-Grade',
    titleHighlight: 'Reliability',
    description: "We don't just write code; we deploy production-ready ecosystems designed for the modern web's demands.",
    features: [
      { icon: 'Layers', title: 'Docker & Containerization', desc: 'Consistent environments across development, staging, and production.' },
      { icon: 'Shield', title: 'DevSecOps Integration', desc: 'Automated security scanning and compliance checks built into every deployment.' },
      { icon: 'Activity', title: 'Observability Stack', desc: 'Real-time metrics and logging using Prometheus and Grafana for proactive maintenance.' },
    ],
    image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDAU_OZS4FxLAVerB0GdajUBz0SkTDs_gCrBeHP71erF_bajltujK0InFEHShKKxviN13Jzw8sbJ2LFBqwOQWt90QSUeprSjwxB6v_kVZl42_7FzgWysSm8jpqJyn77ATSU-RO9jNVQX0yzymKU2x9I1snAH3JdzdveaE1IbBW3rM8uRYJASeDhNABIAtSH7hOJpIaiYZhR_CDmf1eWeTsA1IehasNTrneP-6PW-XyZ0bYvbzUWJTHHOGD0sRtnzEqN65V8OOT-kzNE',
  },
  standards: [
    { title: 'Scalability First', desc: 'Every line of code is written with the expectation of 10x growth. Our architecture prevents the technical debt that cripples scaling startups.' },
    { title: 'AI Ready', desc: "We don't tack on AI as an afterthought. Our data structures and API layers are designed for vector search and LLM context injection from day one." },
    { title: 'Type Safety', desc: 'By leveraging TypeScript and Go, we reduce runtime errors by up to 80%, ensuring a smoother production environment and faster feature releases.' },
  ],
};

export const methodologyData = {
  hero: {
    label: 'Engineered for Velocity',
    titleLine1: 'Precision Delivery',
    titleLine2: 'at Scale.',
    description: 'Our US-based methodology bridges the gap between visionary architecture and production-ready code. We leverage iterative cycles and high-frequency communication to deliver flawless digital ecosystems.',
    chips: ['100% US-BASED SQUAD', 'AGILE FIRST'],
    stat: { value: '99.8%', label: 'On-Time Deployment' },
    image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuDu4F4M0aJfFbK-mnp6tBxv9uvTALqivQ1RDMV1MMbBO0fbGPufw_XWWZk5Cj-v3ufQzYNBS7ksUrW_Tu-UxxtZVyN8cYsm5B5TBanVbaAeF493_yxACyHBPSA-70jkapwsgN--p9YrrreM-KjSuP9MMCG-D3vRnGR-TjPVMjOdKSDAmiodYmwRkarToW797LK6_qkw-ipZrD9TM2D_oPXhmsdxukkqmaDu8heAsmuozBRBrQveRWhKBTmeXt-o9JZ8oEUKRpRNB7nV',
  },
  usAdvantage: [
    { icon: 'Navigation', title: 'Sync Delivery', desc: 'Operate in the same business hours for instant feedback loops and real-time troubleshooting.' },
    { icon: 'Gavel', title: 'Regulatory Compliance', desc: 'Inherent understanding of US data privacy, security standards, and industry regulations.' },
    { icon: 'Users', title: 'Senior Talent', desc: 'Direct access to architects with experience in Fortune 500 stacks and Silicon Valley startups.' },
    { icon: 'MessageSquare', title: 'Cultural Alignment', desc: "Communication that moves past the 'what' to the 'why', ensuring deep product alignment." },
  ],
  timeline: [
    { step: '01', title: 'Discovery & Audit', desc: 'Deep-dive into your existing infrastructure and business logic to define the technical North Star.', tags: ['ARCHITECTURAL MAPPING', 'RISK ASSESSMENT'] },
    { step: '02', title: 'Iterative Sprints', desc: 'Rapid development cycles where features are built, tested, and demonstrated every 14 days.', tags: ['CI/CD AUTOMATION', 'BI-WEEKLY DEMOS'] },
    { step: '03', title: 'Hardened QA', desc: 'Extensive testing including security pen-tests, load balancing, and cross-platform validation.', tags: ['ZERO-DEFECT POLICY', 'PERFORMANCE TUNING'] },
    { step: '04', title: 'Launch & Support', desc: 'Seamless production deployment followed by proactive 24/7 monitoring and evolution.', tags: ['CLOUD OPTIMIZATION', 'SCALE MANAGEMENT'] },
  ],
  lifecycle: {
    monitoring: '24/7',
    sla: '1hr',
  },
};

export const portfolioData = {
  hero: {
    badge: 'Complex Systems Specialist',
    title: 'Architecture for the',
    titleHighlight: 'Intelligent Ether.',
    description: 'ApZelio transforms complex business logic into high-concurrency cloud infrastructure. We build the digital skeletons that power AI-driven ecosystems.',
    stats: [
      { icon: 'Cpu', label: 'Active Nodes', value: '128+ Managed' },
      { icon: 'Gauge', label: 'Avg. Latency', value: '<14ms' },
    ],
    image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuD0lxoI6xjKYcaAPx3pZGI5Odgf-r--byGWIl7HijjG8b0XR5hFC1t2E3374v2zmmRd5dMkSqpqZgjr08lMeazGcLrbgPnfV5g7ofU_EaIe4hIympE_aQ2mi7seL5T8-dX1XOYnUVS5iqvgQEzpO42QjHl5WcO8_eWXcwefDduC6raa1u-P-B3wsquan-eZq1sCuyccHF8N5LSQHAFTyCeawsZEb2NDisHVtoGT74vrAkaJ3Ee5AYEhqEF6S28h9MicHb4zipgtZoLH',
  },
  projects: [
    {
      tags: ['AI Platform', 'AWS'],
      title: 'Project AetherMind',
      description: 'A distributed GPU-orchestration layer for real-time LLM inference. We reduced cold-start latency by 74% using custom Go-based scheduling.',
      metric: { value: '0.4s', label: 'End-to-end latency' },
      image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuAoEO22_ZWIafo-Z2qNozX003Oc_HZjyqqx0g03qws_ZxH9f6Nfwm87cB7VGEtdfzdBojZmMXjUpfLoc8_xx3Tzc5T-4XjaYlIbsl7CwAH0l60kqT8UZN7YdM5XrKE544PW1QXp6Ahb72Pmhy-wGAtLckMmq33r62Gn1TCqRgdBUSQrhcBF5ikmYMKeSi2qT9vS0Ap8MbVXWfyuXur0oTseEAXffrdg0rjd6INdo7Pr-H73gM56Krnzdh-kH3U3n3LWCr6IV_VRX1KF',
      size: 'featured',
    },
    {
      title: 'Titan Ledger',
      description: 'High-frequency transactional engine for fintech. Built on Go/gRPC with sub-millisecond ACID compliance.',
      techTags: ['Go', 'Postgres', 'Redis'],
      metric: { value: '1.2M', label: 'tps' },
      icon: 'Database',
      size: 'small',
    },
    {
      title: 'Omni-Edge CDN',
      description: 'Global content distribution network focusing on dynamic edge-computed security policies.',
      stats: [{ value: '99.99%', label: 'Uptime' }, { value: '120+', label: 'Edge PoPs' }],
      image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuD6scHWX-CZfZngzRyd0f3A1YMvNLgfOe9t7WXslqnmkdZjVw0E-ijMlf0wP4GnR4AG5EC-mFdI3SyFDSFzu0a9tKug2THw544m0Rq9UqROuzWugEIFNqrK_eZzdM5FCz7Nos-a-NLKMhQ22xHBcr1IbWl2C3QjvGhEXMJhKHfVowMJoZsznNl-a6_25R9T8BFijFJWKRlAf1AZi7FhyXsASnNZMkLB2NLBjXgwAAwuPRqaCVnhK3U1nDiOc9ZMyAUveTnmqQ9zYn_v',
      size: 'medium',
    },
    {
      badge: 'Current Venture',
      title: 'Neural Infrastructure Layer',
      description: 'We are currently architecting a proprietary layer for autonomous agent orchestration, focusing on multi-region state synchronization.',
      size: 'wide',
    },
  ],
  techStack: {
    languages: ['Go (Golang)', 'TypeScript', 'Rust', 'Python (ML)'],
    cloudOps: ['AWS (EKS, Lambda)', 'Terraform / IaC', 'Kubernetes', 'Cloudflare Workers'],
  },
};

export const testimonialsData = {
  hero: {
    badge: 'Success Stories',
    title: 'Architecting the future through',
    titleHighlight: 'proven intelligence.',
    description: 'We partner with engineering leaders who refuse to settle for "standard." Here is how ApZelio is redefining the ceiling for AI infrastructure and cloud delivery.',
  },
  testimonials: [
    {
      quote: '"ApZelio didn\'t just build our AI infrastructure; they anticipated the scaling bottlenecks we hadn\'t even encountered yet. Their technical precision and adherence to deadlines is unparalleled in the consultancy space."',
      highlightWord: 'technical precision',
      author: 'Marcus Chen',
      role: 'CTO, NexaGen Systems',
      avatar: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCRreZ0nkmTccV-OepB9890hv1FjX27steWfE34qy0CebO-TzXu_U-eH4prvvErDvZI2M7kqMK0TZ_UnQ0nO4ZW9xgNeTNJPXAyZGI8wABqNMq0xdWXbhukyWQ_UCBBu4CyHJqdt4PmV3anYbYCOCa3UWgCBMv2FrnhKAcG-ndJnrLar2tH-9_KpZH3AiocA5GsCaPUpgxywz_Z2iqUmiHqCIvwPRlZtYTS-ShFbdBVUgkV9pFD0_JGNltjakcw98rloa1158QxvaWO',
      rating: 5,
      size: 'featured',
    },
    {
      quote: '"The team delivered our complex LLM integration 3 weeks ahead of schedule. Truly the fastest engineering pivot we\'ve ever executed."',
      author: 'Elena Rodriguez',
      role: 'VP of Engineering, CloudCore',
      avatar: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCidhfsNJHAzn9imA1YbjLpl9D4oxb9Pqyp_C5W79_g4pFGNZbpNtX5WwaDRIVRn_zpgOEUMx-ztNm6ftIBFSRm49N8I7gMRolU4sAzrmTQvqgY0jg4mH3DY-4KRl6gttoO9pbyBZ36wFIlNFbVw_vH_wJ2Vh1HQ3Gx252PLgFwekGzmrbKweu74fxPL6b7efES9QYeCl8FZKQEUVSgrxSdZwivuU7SR0uXmcIeHgJR0pA5Yl3NlIvSxcgClDXvdIYUovf7UM94JwVg',
      size: 'small',
    },
    {
      quote: '"When we approached ApZelio, our latency was killing our user retention. Their architects re-engineered our entire vector database strategy in under a month. It\'s rare to find a partner that speaks both business outcomes and low-level Go optimization with equal fluency."',
      title: 'Scaling Deep-Tech in Record Time',
      author: 'David Vance',
      role: 'Director of AI, Sentinel Logic',
      avatar: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCGL7lVWJ0OEy6JsZENJjQ_9gjOCo5EK65bDiUFzgYt5NmFnfZ90p1lnaS0AuNicf3bh--tXCBPug_VCANPVAONhNVOpQryvUGOun3cL6PVz9jEvhPHTf2focWG2rCwJxcuCpmq7VV3HvyYBNqhnmytoIrBcknzKfbyaei2szPqn7ujTmiEfVcx7mbxVjlOFdaBb-INVRYVjoAaBD49cs7wRuv92ibRQjj6ncoNfCZXJIxfjeK5mE7GlBX48y8NFiNmWuO46Kg_s_Lg',
      image: 'https://lh3.googleusercontent.com/aida-public/AB6AXuCc8e-vwusPDEyIhBEoKKcbatRCBuH5ebEvd9vblK4xmn6YM5DQfJAg0VQ9wW1sZkgD_FZTx0kPjOyHuEpWwT4EPlHm-B31dtRHjeSzUBidxBlj-RYMOpTgWZpWcjSmPm_ln_qRND8df0_UcVf3j5G1sMuwQg0re6Wc2zrVNmTk07Yb6HBolRcFmYGSvF7OUiyu8jChtWhnMYtgWhnYQ7AIim1dEPsB_yCa0DAhQGOF5cXLAWl0ZC_MFxT86HxI3ywUZIaSmNe2fB9m',
      size: 'wide',
    },
  ],
  metric: { value: '98%', label: 'On-Time Delivery Rate', sublabel: 'Based on 45+ enterprise-scale AI deployments in 2023-2024.' },
  logos: [
    'https://lh3.googleusercontent.com/aida-public/AB6AXuDBDfNPStDqaXdMGVr6u0zdGWXOLbcUupCf7bY3FP3KPC-5glNGO_apVSTOSIlDpG4SWo2M9aU1WjMJbV50o6XK1pnDj__OpCaiZZE77JIZbznQpvOOQOJ34lMvGGkPs_NgesVVbOXIes6o1Vt6ruODNLWXPUCgU9aFqC6_EH9-whFLEc7IywANDUe7VWP-4VmAVvLabGvdF3398rKRcxwa80s_WAxmwfID9dffzPKiv0TQ-Ob7ZXAqZpwhKgw5gTL9XDfYHezmGLw3',
    'https://lh3.googleusercontent.com/aida-public/AB6AXuCWbiUo_uVgS1p2Wc1B5m36z4JX6zMMhhjvAwmDULCTTzE0frIJjR9Ew9huDKcrdmIo9N1frnbgSCFWdnjjZmXHNo6P57McaM4Pod3djABOTI7dnopDImOiFmMs6qt9tC6I4pfF01666Rfcow757-NpRpK0iwBlfYvOsb8GfUpDNdEtJ9LN3k3CYTuV1CE4usrJ5wWlK3mimv3yHsdBRQhnRM7W8viqTTBNYj-88KoJoJ-qBF8RJtwZJpNn0A5aDKUpwafLVdsVV3N_',
    'https://lh3.googleusercontent.com/aida-public/AB6AXuCMFSepI61fr7jvqvWsdCR96Spw6CDaSZlO3tFmt5ixOZe4xEZQ6xphSMTLIivTinO7nEvBHI9fZTbBYYLM6yT0_KgnUUOV8wtNnlSqxvyb4Yhj31abSa6HtQBC4RHeNLHe99TKDpvDjfTOnjGIDAujV9NqWvXwLNsXiWFlKHLWuMnhO_WWLYuskK2xFn_sDcEzdVNBwalMfnttDqigRkj814E__nZ7VaLVfogrVQ55Tfrx0z2sAef0ksswnMBMwyZpxaR7vM019f8z',
    'https://lh3.googleusercontent.com/aida-public/AB6AXuC93GUUHkASypKdpJyJlkaYqkpMZmDFr0YNp9liExGCv8vRktpqt8tQclyYwC7Oxy6tBnhp1X89ZvUmHVjmx3WJHAFz7l_bgyIFW3xon-yU-ahU9qd-QrcPrqJ-5HKUL3-VTF_7aOdbLYkftaV1ZZox2zcIaqVytrx76NWf1qgrTr54ZDtbuT3cBK_GcHG4DlxwaLKAFDg-dDuBXezFh5GwCW0328YvqOHdVkQ3bWi3M_bzt_Hre3ZygOSdHzhSknu3pEuhnhvWvO4-',
    'https://lh3.googleusercontent.com/aida-public/AB6AXuBM5Dz2UuGjsQlYFXVEVqN6O1ZqiTuddA4jZoEYoCq1313q6nIsBjk8UokKXNzu1_9aMd747xEQcejYydCH6erLFVDzSfbACugUTW77_3sc890FrGx3C47oFkgouC8oJ1UXZgzxcLLj7_LQTYj9vAHBnoTJ0emCGw0KqhEg14DYCeSvPjL-OxcM9Vs8OOdWEM8tHtEg3t6bwwJzDm1T5Q3A3nV3G5fjGTR5LJk9eH_5knHBwDfe-HApAbdi4UlIQhSkzYkVBdGAJaj9',
  ],
};

export const footerData = {
  brand: 'ApZelio',
  tagline: 'Engineering digital excellence through AI and high-performance architecture.',
  quickLinks: ['Blog', 'Privacy Policy', 'Terms of Service'],
  social: ['LinkedIn', 'Github'],
  copyright: '© 2024 ApZelio. US-Based Digital Excellence.',
};
